__turbopack_context__.v({
  "article_description": "Nx7aoq_article_description",
  "article_headline": "Nx7aoq_article_headline",
  "article_image": "Nx7aoq_article_image",
  "article_image_link": "Nx7aoq_article_image_link",
  "article_over_title": "Nx7aoq_article_over_title",
  "article_thumbnail": "Nx7aoq_article_thumbnail",
  "articles": "Nx7aoq_articles",
  "articles_title": "Nx7aoq_articles_title",
  "splide__arrow": "Nx7aoq_splide__arrow",
});
